import {useRouter} from 'next/router';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import useCandidatesSearchLocationFilter from '@/src/jobPortal/allCandidates/utils/useCandidatesSearchLocationFilter';
import FilterRow from '@/src/Search/components/FilterRow';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

interface AllCandidatesLocationFilterProps {
  onChangeHandler: (...args: any) => any;
}

const AllCandidatesLocationFilter = ({
  onChangeHandler,
}: AllCandidatesLocationFilterProps) => {
  const {candidatesLocations} = useCandidatesSearchLocationFilter();
  const {locale, query} = useRouter();

  if (!candidatesLocations) {
    return null;
  }

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'profile.location'} />
        </Text>
      }
    >
      {candidatesLocations.map((locationItem) => {
        return (
          <FilterRow key={`location_${locationItem.id}`}>
            {/* @ts-ignore */}
            <CheckboxCommon
              id={`location_${locationItem.id}`}
              name={locationItem[`name_${locale}`]}
              label={locationItem[`name_${locale}`]}
              data-filter-name={SEARCH_FILTERS.COUNTRY_IDS}
              data-value={locationItem.id}
              checked={
                !!query[SEARCH_FILTERS.COUNTRY_IDS] &&
                // @ts-ignore
                JSON.parse([query[SEARCH_FILTERS.COUNTRY_IDS]]).includes(
                  String(locationItem.id)
                )
              }
              onChange={onChangeHandler}
              isSemibold
            />
          </FilterRow>
        );
      })}
    </SimpleCollapse>
  );
};

export default AllCandidatesLocationFilter;
